import styled from '@emotion/styled';

import { color, font, shadow } from 'src/shared/styles/variables';

export const TipCard = styled('div')({
    padding: '0 1rem',
    marginBottom: '2rem',
    flex: '1 0',
    minWidth: '33.33%',
    maxWidth: '33.33%',
});

interface CardContentProps {
    clickable: boolean;
    centered?: boolean;
}

export const CardContent = styled('div')((props: CardContentProps) => ({
    borderRadius: 5,
    boxShadow: shadow.lightCardShadow,
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    border: `1px solid ${color.gallery}`,
    paddingBottom: '2rem',
    cursor: props.clickable ? 'pointer' : 'auto',
    transition: 'all 0.2s ease-in-out',
    textAlign: props.centered ? 'center' : 'left',
    '&:hover': {
        borderColor: props.clickable ? color.royalBlueSaturated : color.gallery,
    },
}));

export const CardIconHolder = styled('div')({
    padding: '1rem',
    backgroundColor: color.polar,
});

interface CardIconProps {
    iconUrl: string;
}

interface CardIconProps {
    iconUrl: string;
    smallIcon?: boolean;
}

export const CardIcon = styled('i')<CardIconProps>(({ iconUrl, smallIcon }) => ({
    display: 'block',
    backgroundImage: `url('${iconUrl}')`,
    height: smallIcon ? '1.5rem' : '9rem',
    maxWidth: smallIcon ? '1.5rem' : '10rem',
    margin: smallIcon ? '0' : '0 auto',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPositionX: 'center',
}));

export const CardTitle = styled('h3')(
    {
        width: '100%',
        padding: '2rem 2rem 0',
        margin: 0,
        color: color.blueLagoon,
        backgroundColor: color.white,
    },
    font.heavy(font.size.medium),
);

export const CardText = styled('p')(
    {
        padding: '1rem 2rem 0',
        color: color.tundora,
    },
    font.book(font.size.medium),
);
